<template>
  <div class="content-box">
    <!--    上方盒子-->
    <div class="father-box" ref="topBox">
      <el-card class="top-card" style="height: 100%">
        <div class="car-box">
          <el-row>
            <span>终端信息</span>
          </el-row>
          <el-form :inline="true" :model="formQuery" class="demo-form-inline">
            <el-form-item label="终端IMEI号 : ">
              <el-input v-model="formQuery.vin" size="mini" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="终端工作状态 : ">
              <el-select v-model="formQuery.terminalWorkStatus" size="mini" placeholder="请选择">
                <el-option
                    v-for="item in terminalWorkStatusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button @click="search()" type="primary" size="mini">查询</el-button>
              <el-button @click="reset()" size="mini">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="padding-box">
          <el-table
              class="tableListValue"
              ref="tableRef"
              :data="tableData"
              stripe
              style="width: 100%;overflow-y: auto; height: 600px;">
            <el-table-column label="序号" prop="id" type="index" width="60" align="center">
            </el-table-column>
            <el-table-column
                align="center"
                prop="vin"
                label="终端IMEI号">
            </el-table-column>
            <el-table-column
                align="center"
                prop="onlineStatus"
                label="终端工作状态">
              <template slot-scope="scope">
                {{ onlineStatusObj[scope.row.onlineStatus] }}
              </template>
            </el-table-column>
            <el-table-column
                align="center"
                prop="powerOnTime"
                label="最近一次终端上电时间">
              <template slot-scope="scope">
                {{ scope.row.powerOnTime || '-' }}
              </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="操作">
              <template slot-scope="scope">
                <el-link @click="lookTrajectory(scope.row)" :underline="false" type="primary"
                         style="font-weight: 700">
                  查看轨迹
                </el-link>
              </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="高频采集">
              <template slot-scope="scope">
                <el-switch
                    v-model="scope.row.frequencyStatus === 1 ? true : false"
                    @change = "beforeOpenHighFrequency(scope.row)"
                    active-color="#13ce66"
                    inactive-color="#ff4949">
                </el-switch>


              </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="数据时间同步">
              <template slot-scope="scope">
                <el-switch
                    v-model="scope.row.timeAlignState === 1 ? true : false"
                    @change = "beforeOpenTimeAlignState(scope.row)"
                    active-color="#13ce66"
                    inactive-color="#ff4949">
                </el-switch>


              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="formQuery.currentPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="formQuery.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
          </div>
<!--          提示框-->
          <el-dialog
              title="请注意"
              :visible.sync="dialogVisible"
              width="30%"
              :before-close="handleClose">
            <span>{{dialogText}}</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="changeHighFrequencyAcquisition(row)">确 定</el-button>
            </span>
          </el-dialog>
          <!--          提示框-->
          <el-dialog
              title="请注意"
              :visible.sync="timeAlignStateDialogVisible"
              width="30%"
              :before-close="handleClose">
            <span>{{timeAlignStateDialogText}}</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="timeAlignStateDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="changeTimeAlignState(row)">确 定</el-button>
            </span>
          </el-dialog>

        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import {getDataInstructList} from "../../common/command";
import fa from "element-ui/src/locale/lang/fa";
import {getVehicleList, highFrequencyOnOff, timeAlignmentOnOff} from "@/common/dataReportingApi";

export default {
  name: "dataReporting",
  data() {
    return {
      row: {},
      total: 0,
      formQuery: {
        currentPage: 1,
        pageSize: 10,
        vin: '',
        terminalImei: '',
        terminalWorkStatus: ''
      },
      terminalWorkStatusList: [
        {
          value: 0,
          label: '离线'
        },
        {
          value: 1,
          label: '在线'
        }
      ],
      onlineStatusObj: {
        0: '离线',
        1: '在线',
      },
      tableData: [],
      dialogVisible: false,
      dialogText: '开启高频采集后,会消耗更多流量!!',
      timeAlignStateDialogVisible: false,
      timeAlignStateDialogText: '开启数据时间同步功能，请确认车辆双路总线都能采集到数据，否则会导致数据无法上传平台!!\n' +
          '指令下发后，请重启设备生效!'


    }
  },
  created() {
  },
  mounted() {
    this.initTerminalWorkStatusList()
    this.initTable();
  },
  destroyed() {
  },
  methods: {

    // 获取列表
    async initTable() {
      this.tableLoadingType = true
      try {
        const param = {
          pageNo: this.formQuery.currentPage,
          pageSize: this.formQuery.pageSize,
          vin: this.formQuery.vin,
          imei: this.formQuery.terminalImei,
          onlineStatus: this.formQuery.terminalWorkStatus
        }
        const res = await getVehicleList(param)
        console.log(res)
        if (res.code === 200) {
          this.tableData = res.data
          this.total = res.total

        } else {
          this.$notify.error({
            title: '错误提示',
            message: res.msg
          });
          this.tableLoadingType = false
        }
      } catch (e) {
        this.tableLoadingType = false
        console.log(e)
      }
    },
    beforeOpenHighFrequency(row){
      if (row.frequencyStatus === 0){
        this.row = row
        this.dialogVisible = true
      }else {
        this.changeHighFrequencyAcquisition(row)
      }
    },
    beforeOpenTimeAlignState(row){
      if (row.timeAlignState === 0 && row.onlineStatus === 1){
        this.row = row
        this.timeAlignStateDialogVisible = true
        this.timeAlignStateDialogText = '开启数据时间同步功能，请确认车辆双路总线都能采集到数据，否则会导致数据无法上传平台!!\n' +
        '指令下发后，请重启设备生效!'
      }else {
        this.changeTimeAlignState(row)
      }
    },
    // async getDataInstructList() {
    //   this.tableLoadingType = true
    //   try {
    //     const param = {
    //       pageNo: this.currentPage,
    //       pageSize: this.pageSize,
    //     }
    //     const res = await getDataInstructList(param)
    //     // console.log(res)
    //     if (res.code === 200) {
    //       this.instructList = res.data
    //     } else {
    //       this.$notify.error({
    //         title: '错误提示',
    //         message: res.msg
    //       });
    //       this.tableLoadingType = false
    //     }
    //   } catch (e) {
    //     this.tableLoadingType = false
    //     console.log(e)
    //   }
    // },
    getIndex(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1
    },
    handleClose() {
      this.dialogVisible = false
    },
    async initTerminalWorkStatusList() {
      // const res = await getTerminelList()
      // console.log(res)
    },
    // 查看轨迹
    lookTrajectory(item) {
      sessionStorage.setItem('navIdentification', 18)
      this.$router.push({name: 'trackQuery', params: item})
    },
    changeHighFrequencyAcquisition(row){
      this.dialogVisible = false
      console.log("scope.row::",row)

      let check = row.frequencyStatus
      let onlineStatus = row.onlineStatus
      let vin = row.vin

      let params = {
        imei: vin,
        status: check === 1 ? 0 : 1
      }
      console.log("params::",params)
      highFrequencyOnOff(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: res.msg,
            type: 'success'
          });
          this.initTable()
        } else {
          this.$notify.error({
            title: '错误提示',
            message: res.msg
          });
        }
      })


    },
    changeTimeAlignState(row){
      this.timeAlignStateDialogVisible = false
      console.log("scope.row::",row)

      let check = row.timeAlignState
      let onlineStatus = row.onlineStatus
      let vin = row.vin

      let params = {
        imei: vin,
        status: check === 1 ? 0 : 1
      }
      console.log("params::",params)
      timeAlignmentOnOff(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: res.msg,
            type: 'success'
          });
          this.initTable()
        } else {
          this.$notify.error({
            title: '错误提示',
            message: res.msg
          });
        }
      })


    },
    checkCarOnline(onlineStatus){
      console.log("checkCarOnline-onlineStatus::",onlineStatus)
      if (onlineStatus === 1){
        return true;
      }else {
        return false;
      }
    },
    search() {
      this.formQuery.currentPage = 1
      this.formQuery.pageSize = 10
      this.initTable()
    },
    reset() {
      this.formQuery = {
        currentPage: 1,
        pageSize: 10,
        vin: '',
        terminalImei: '',
        terminalWorkStatus: ''
      }
      this.initTable()
    },
    handleSizeChange(e) {
      this.formQuery.pageSize = e
      this.initTable()
    },
    handleCurrentChange(e) {
      this.formQuery.currentPage = e
      this.initTable()
    },
    handleSelectionChange() {
    }
  }
}
</script>

<style scoped>

.pagination {
  margin-top: 10px;
  text-align: right;
}

.father-box {
  height: 98%;
}






.padding-box {
  height: 90%;
  background: #ffffff !important;
  text-align: left;
  padding: 0 20px;
}


.top-card {
  //overflow: auto; /* 自动开启滚动条 */
  //max-height: 950px; /* 设置最大高度 */
  //max-width: 1760px; /* 设置最大宽度度 */
  //margin-left: 5%;
  border-radius: 10px;
}

.car-box {
  height: 10%;
  text-align: left;
  border-radius: 10px;
  padding: 20px 30px;
}



</style>
